import React, {Fragment, Suspense} from 'react';

import {withAuthenticator} from 'aws-amplify-react/dist/Auth';
import SignIn from 'aws-amplify-react/dist/Auth/SignIn'
import VerifyContact from 'aws-amplify-react/dist/Auth/VerifyContact'
import ConfirmSignIn from 'aws-amplify-react/dist/Auth/ConfirmSignIn'
import ForgotPassword from 'aws-amplify-react/dist/Auth/ForgotPassword'
import RequireNewPassword from 'aws-amplify-react/dist/Auth/RequireNewPassword'

import {Button, Layout, Spin} from 'antd';
import {connect} from 'react-redux';
import {initApp} from "../store/actions/bookings";
import {openNotificationWithIcon} from "../store/notificationService";
import instance from "../api/api";
import {Auth} from '../api/amplify';
import {withRouter} from "react-router";
import Instagram from "../theme";
import LayoutTitle from './LayoutTitle';
import TopNav from './TopNav';
import BookingSelector from './BookingSelector';
import UpgradeRequired from "./UpgradeRequired";
import {portalTypeGlobalState, setUpgradeRequired} from "../store/actions/global";
import OwnerPortal from "./OwnerPortal";
import SkeletonWrapper from "./Skeleton";
import getEnv from '../service/getEnv';

const {Content, Footer} = Layout;

let responseInterceptor = false;

const clientName = getEnv();

const InnerApp = React.lazy(() => import("./InnerApp"));

class GuestPortal extends React.Component {

    retryBookings = () => {
        this.props.dispatch(initApp());
    };

    componentDidMount() {
        if (this.props.authState && this.props.authState !== 'signedIn') {
            return null;
        }

        //we need to figure out whether we are inside a guest portal or owner portal
        this.props.dispatch(portalTypeGlobalState(window.location.hostname));


        //this.props.dispatch(portalTypeGlobalState("ownerportal.co.uk"));

        if (responseInterceptor) {
            instance.interceptors.response.eject(responseInterceptor);
        }
        responseInterceptor = instance.interceptors.response.use(
            response => response,
            error => {
                // Do something with response error
                const response = error.response;
                switch (response.status) {
                    case 403:
                        //our token isnt valid anymore, lets logout
                        Auth.signOut()
                            .then(() => {
                                openNotificationWithIcon('info', 'You\'ve been logged out.', 'Please login to carry on using our app.');
                                this.props.onStateChange('signedOut', null);
                            })
                            .catch(() => {
                                this.props.onStateChange('signedOut', null);
                                //openNotificationWithIcon('error', 'Error', 'There has been a problem logging you out. Please try again.');
                            });
                        return Promise.reject(error);
                    case 404:
                        return Promise.reject(error);
                    case 500:
                        openNotificationWithIcon('error', 'Error', 'There has been an error processing your request, please try again.');
                        return Promise.reject(error);
                    case 426:
                        //need to upgrade the front end assets
                        this.props.dispatch(setUpgradeRequired());
                        return true;
                    default:
                        return Promise.reject(error);
                }
            });
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(prevProps.portalType === false && (this.props.portalType !== false && (this.props.portalType === "owner" || this.props.portalType === "guest"))) {
            //we just found out which portal type we are, lets instansiate the correct app.
            if(this.props.portalType === "guest") {
                this.props.dispatch(initApp());
            }
        }
    }

    render() {
        if (this.props.authState && this.props.authState !== 'signedIn') {
            return null;
        }

        if(this.props.portalType === false) {
            return <SkeletonWrapper className="bg--white p-t-10 p-b-10 p-r-10 p-l-10" />;
        }
        if(this.props.portalType === "owner") {
            return <OwnerPortal />
        }

        return <Suspense fallback={<Fragment />}>

        <Layout className={`rerum-app rerum-client-${clientName}`} >

                {this.props.loading ?
                    <div style={{width: "200px"}}>

                    </div>
                    :
                    this.props.failed ?
                        <div style={{width: "200px"}}>

                        </div> :
                        <React.Fragment>
                            {this.props.upgradeRequired ?
                                <UpgradeRequired/>
                                : null}
                            <TopNav {...this.props} />
                        </React.Fragment>
                }
                <Layout>
                    {!this.props.loading ?
                        <BookingSelector/>
                        :
                        null
                    }

                    <Content>
                        {this.props.failed ?

                            <Fragment>
                                <div style={{textAlign: "center"}} className="m-t-50">
                                    Sorry we could not load your bookings, please try again.
                                </div>
                                <p/>
                                <div style={{textAlign: "center"}}>
                                    <Button type="primary" icon="redo" size='large' onClick={this.retryBookings}
                                            loading={this.props.loading}>Retry</Button>
                                </div>
                            </Fragment>
                            :

                            this.props.loading ?
                                <div className="app-init-spinner">
                                    <div style={{textAlign: 'center'}}>
                                        Loading your bookings...
                                    </div>
                                    <p/>
                                    <Spin size="large"/>
                                </div>
                                :
                                <div style={{padding: 6, minHeight: 360}}>
                                    <LayoutTitle/>
                                    <InnerApp />
                                </div>

                        }
                    </Content>
                    <Footer style={{textAlign: 'left'}}>
                        {(new Date().getFullYear())} &copy; res:harmonics | The Apartment Management Software Company
                    </Footer>
                </Layout>
            </Layout>
        </Suspense>
            ;
    }
}

const GuestPortalWithAuth = withAuthenticator(GuestPortal, false, [
    <SignIn/>,
    <ConfirmSignIn/>,
    <VerifyContact/>,
    <ForgotPassword/>,
    <RequireNewPassword/>
], null, Instagram);

const mapStateToProps = state => {

    const reference = state.bookings.availableBookings.filter(booking => (
        booking.uuid === state.bookings.selectedBookingId
    ));

    return {
        availableBookings: state.bookings.availableBookings,
        loading: state.bookings.loading,
        selectedBookingId: state.bookings.selectedBookingId,
        failed: state.bookings.failed,
        selectedReference: reference && reference.length > 0 ? reference[0].bookingReference : false,
        upgradeRequired: state.global.upgradeRequired,
        portalType: state.global.portalType,
    };
};

export default withRouter(connect(mapStateToProps)(GuestPortalWithAuth));
